<template>
  <div class="login">
    <div class="container">
      <v-snackbar v-model="loginSuccess" color="success" top>
        <span>
          Autenticidade verificada. Sua nota será baixada em seguida para
          visualização.
        </span>
        <v-btn color="info" @click="loginSuccess = false">Ok</v-btn>
      </v-snackbar>

      <v-snackbar color="error" v-model="loginFail" top>
        <span>
          Falha na autenticação! Favor verificar os dados informados ou entre
          em contato com a Prefeitura.
        </span>
        <v-btn color="info" @click="loginFail = false">Fechar</v-btn>
      </v-snackbar>

      <h1 class="display-1 my-3">{{labelVerificarAutenticidade}}</h1>
      <v-divider></v-divider>
      <v-row wrap justify="center">
        <v-flex xs12 sm6 xl4>
          <v-card hover class="ma-4">
            <v-card-title>Autenticidade</v-card-title>
            <v-card-text>
              <span
                class="body-2">
                {{messageDescritivoAutenticidade}}
              </span>

              <v-form ref="form" class="my-3">
                <v-text-field
                  v-mask="['XXX.XXX.XXX-XX', 'XX.XXX.XXX/XXXX-##']"
                  clearable
                  v-model="cpfCnpj"
                  @input="cpfCnpj = cpfCnpj.toUpperCase()"
                  :rules="regrasObrigacao"
                  label="CNPJ do Prestador de Serviços"
                  required
                  prepend-icon="account_circle"
                ></v-text-field>

                <v-text-field
                  v-mask="['#########']"
                  clearable
                  v-model="numeroNota"
                  :rules="regrasObrigacao"
                  :label="labelNumeroNfse"
                  required
                  prepend-icon="description"
                ></v-text-field>

                <v-text-field
                  v-mask="['#################################################']"
                  clearable
                  v-model="im"
                  :rules="regrasObrigacao"
                  label="Inscrição Municipal"
                  required
                  prepend-icon="assignment"
                ></v-text-field>

                <v-text-field
                  v-model="codigo"
                  clearable
                  :rules="regrasObrigacao"
                  label="Código de verificação "
                  required
                  prepend-icon="aspect_ratio"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color="primary" dark type="submit" @click="verificarAutenticidade">
                <v-icon small left>check_circle</v-icon>
                <span>Verificar</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-row>
    </div>
  </div>
</template>

<script>
import {mask} from "vue-the-mask";
import EventService from "@/services/EventService";

export default {
  directives: { mask },
  data() {
    return {
      cpfCnpj: null,
      im: null,
      numeroNota: null,
      codigo: null,
      regrasObrigacao: [(v) => !!v || "Campo obrigatório!"],
      loginSuccess: false,
      loginFail: false,
      labelVerificarAutenticidade: "",
      messageDescritivoAutenticidade: "",
      labelNumeroNfse: "",
    };
  },
  created() {
    EventService
        .getBundle("label.portalVerificarAutenticidade")
        .then(res => this.labelVerificarAutenticidade = res.data)

    EventService
        .getBundle("message.portalDescritivoAutenticidade")
        .then(res => this.messageDescritivoAutenticidade = res.data)

    EventService
        .getBundle("label.portalNumeroNfse")
        .then(res => this.labelNumeroNfse = res.data)
  },
  methods: {
    verificarAutenticidade() {
      if (!this.$refs.form.validate()) {
        // console.log("Erro!");
      } else {
        this.cpfCnpj = this.removeMask(this.cpfCnpj);

        this.$httpNF(
          `notafiscal/autenticacao/cpfCnpj/${this.cpfCnpj}/inscricaoMunicipal/${this.im}/numeroNota/${this.numeroNota}/codigoVerificacao/${this.codigo}`,
          {
            method: "GET",
            responseType: "blob",
          }
        )
          .then((res) => {
            if (res.data.size !== 0) {
              this.loginSuccess = true;
              let blob = new Blob([res.data], {
                type: "application/pdf",
              });
              let link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              link.download = "notafiscal_autentica";
              link.click();
            } else {
              this.loginFail = true;
            }
            // let blob = new Blob([res.data], {
            //   type: "application/pdf"
            // });
            // let url = window.URL.createObjectURL(blob);
            // window.open(url);
          })
          .catch((error) => {
            console.log(error);
            this.loginFail = true;
          });
      }
    },
    removeMask(mask) {
      return mask.replace(/[^a-zA-Z0-9]/g, "");
    },
  },
};
</script>
